import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import { chartThemeColorsBar, chartThemeVerticalBar } from "./index";
import { FiBarChart2, FiTrendingUp, FiActivity } from "react-icons/fi";

const parseData = (data) => {
  if (data && (data.length || Object.keys(data)?.length))
    return {
      bar: data.bar ? Object.values(data.bar) : Array.isArray(data) ? data : [],
      total: data?.total ? data.total : [],
      colors: Array.isArray(data) && data[0]?.color ? data.map((item, index)=> item?.color || chartThemeColorsBar[index]) : [],
    };
  return {
    bar: [],
    total: [],
    colors: []
  };
};

const VerticalBarWidget = ({ data, heading, size, handleReq = null, url=null, loading=false, defaultType="bar" }) => {
  
  const [formatData, setFormatData] = useState({
    bar: null,
    total: [],
    colors: []
  });
  const [chartType, setChartType] = useState(defaultType);

  useEffect(() => {
    if(data){
      setFormatData(parseData(data));
    }else{
      setFormatData({
        bar: null,
        total: [],
        colors: []
      })
    }
      
  }, [data]);
    
  return (
    <div className={`col row mx-0 mt-3 ${size} px-2 position-relative`}>
    <div className="row px-0 mx-0 justify-content-between col col-12 ">
      <div className="dashboard__card col col-12 w-100 flex-basis-100">
        {heading ? (
          <div className="d-flex justify-content-between align-items-center mb-2 mt-0">
            <h5 className="my-0 text-capitalize" style={{ fontWeight: 600, color: '#333' }}>{heading}</h5>
            {formatData.bar && (
              <div className="d-flex align-items-center" style={{ gap: '2px', background: '#e9ecef', padding: '2px', borderRadius: '16px' }}>
                <div 
                  className="d-flex justify-content-center align-items-center rounded-circle" 
                  style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'bar' ? '#fff' : 'transparent', boxShadow: chartType === 'bar' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                  onClick={() => setChartType('bar')}
                  title="Vertical Bar Chart"
                >
                  <FiBarChart2 size={14} color={chartType === 'bar' ? '#0d6efd' : '#495057'} />
                </div>
                <div 
                  className="d-flex justify-content-center align-items-center rounded-circle" 
                  style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'hbar' ? '#fff' : 'transparent', boxShadow: chartType === 'hbar' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                  onClick={() => setChartType('hbar')}
                  title="Horizontal Bar Chart"
                >
                  <FiBarChart2 size={14} style={{ transform: 'rotate(90deg)' }} color={chartType === 'hbar' ? '#0d6efd' : '#495057'} />
                </div>
              </div>
            )}
          </div>
        ) : ""}
        <div className="d-flex flex-col mx-3 my-2" style={{ gap: "3rem" }}>
          {formatData.total?.length > 0 && formatData.total.map((total) => (
            <div>
              <p className="mb-0 font-weight-bold">
                {total.formated_value ? total.formated_value : total.value}
              </p>
              <p className="mb-0" style={{ fontSize: "0.75rem" }}>
                {total.name}
              </p>
            </div>
          ))}
        </div>
        {
         formatData.bar ? (
            <Chart
              width="100%"
              height= {heading === "Production" ? "350px" :"220px"}
              type={chartType === 'hbar' ? 'bar' : chartType}
              series={[
                {
                  name: heading,
                  data: formatData.bar.map((data) => parseFloat(data.value)),
                },
              ]}
              options={{
                chart: {
                  type: chartType === 'hbar' ? 'bar' : chartType,
                  toolbar: { 
                    show: true,
                    tools: {
                      download: true,
                      selection: false,
                      zoom: false,
                      zoomin: false,
                      zoomout: false,
                      pan: false,
                      reset: false
                    }
                  },
                  animations: { enabled: true, easing: 'easeinout', speed: 800 }
                },
                plotOptions: {
                  bar: {
                    horizontal: chartType === 'hbar',
                    distributed: true,
                    borderRadius: 4,
                    columnWidth: "45%"
                  },
                },
                fill: {
                  type: 'solid',
                },
                colors: (heading === "Production") ? chartThemeVerticalBar : (formatData.colors?.length ? formatData.colors : chartThemeColorsBar),
                dataLabels: {
                  enabled: false,
                },
                tooltip: {
                  enabled: true,
                  theme: 'light',
                  x: {
                    show: true
                  },
                  y: {
                    enabled: true,
                    formatter: function(value){
                      return value.toFixed(2);
                     }
                  }
                },
                xaxis: {
                  categories: formatData.bar.map((data) => data.name),
                  labels: {
                     show: heading === "Production",
                 rotate: -70,
                     style:{
                      fontSize:"10px"
                     }
                    },
                },
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return value;
                    },
                    style:{
                      fontSize:"10px"
                    }
                  },
                 
                  tickAmount: 5,
                },
                
                legend: {
                  show: heading !== "Production" && chartType === 'bar',
                  fontSize:"10px",
                  position: "bottom",
              
                }
              }}
            />
            ): (
              <div className="btn_load">
                {
                  loading ? (
                    <>
                      {/*loading */}
                      <CustomSpinLoader loading={loading}/>
                    </>
                  ) : (
                    <button className="btn btn-sm btn-primary rounded-md" onClick={()=>url && handleReq(url)}>Load Data</button>
                  )
                }
              </div>
           )
         }
      </div>
    </div>
  </div>
  )
}

export default VerticalBarWidget
